import { jsx } from "react/jsx-runtime";
import { IconButton } from "../IconButton/index.js";
import { Tooltip } from "../Tooltip/index.js";
import { cn } from "../../utils/cn.js";
const toolTipClass = 'data-disabled:cursor-not-allowed test cursor-pointer';
function CounterIconButton({ type, ariaLabel, ariaControls, onClick, buttonType, disabled, tooltipProps, iconButtonProps = {}, emphasis }) {
    const { iconName = 'increment' === type ? 'add' : 'remove', size = 'sm', ...restProps } = iconButtonProps;
    const Button = /*#__PURE__*/ jsx(IconButton, {
        "aria-label": ariaLabel,
        "aria-controls": ariaControls,
        onClick: onClick,
        type: buttonType,
        iconName: iconName,
        size: size,
        emphasis: emphasis,
        disabled: disabled,
        ...restProps
    });
    if (tooltipProps?.children) {
        const { className, ...restTooltipProps } = tooltipProps;
        const tooltipEmphasis = 'bold' !== emphasis;
        const toolTipClasses = cn(toolTipClass, className);
        return /*#__PURE__*/ jsx(Tooltip, {
            "data-testid": "tooltip-result",
            ...restTooltipProps,
            emphasis: tooltipEmphasis,
            className: toolTipClasses,
            triggerNode: Button
        });
    }
    return Button;
}
export { CounterIconButton };
